import { mapState } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      loading: state => state.loading
    }),
  }
}